module.exports = __webpack_public_path__ + "d477d25d89e94fe3c1ce8eb446708bea.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/alex-kaminsky.jpg
 ** module id = 399
 ** module chunks = 0
 **/